import {Component, ViewEncapsulation, inject} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {LayoutService} from "../../../shared/services/layout.service";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";

@Component({
    selector: 'app-global-footer',
    imports: [
    NgOptimizedImage,
    TranslatePipe,
],
    templateUrl: './bar-global-footer.component.html',
    styleUrl: './bar-global-footer.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class GlobalFooterComponent{
    public layoutService: LayoutService = inject(LayoutService);
    
}